export default "__VITE_ASSET__CdKBZy3D__"